import { useIntl } from 'react-intl';

import { useCommonGameSet } from '@sorare/core/src/set';

export const useInviteShareMessage = (
  referrerCode: string | null | undefined
): string | undefined => {
  const { formatMessage } = useIntl();
  const commonGameSet = useCommonGameSet();

  if (!referrerCode) return undefined;

  return formatMessage(
    {
      defaultMessage: "I'm playing {set} on Sorare, join me! Code: {code}",
    },
    { code: referrerCode, set: commonGameSet.name }
  );
};
